import { normalize } from '@app/helpers';
import styled from '@2pulse/responsive';

const BaseSeparator = styled.View({
  flexDirection: 'row',
  alignItems: 'center',
  margin: normalize(20),
});

const SeparatorLine = styled.View(({ theme }) => ({
  flex: 1,
  height: 3,
  backgroundColor: theme.colors.gold,
}));

const SeparatorText = styled.Text(({ theme }) => ({
  color: theme.colors.babypowder,
  fontFamily: 'Work Sans',
  fontSize: normalize(20),
  fontWeight: '600',
  marginHorizontal: normalize(15),
  textTransform: 'uppercase',
}));

export const Separator = ({ value }: { value: string }) => {
  return (
    <BaseSeparator>
      <SeparatorLine />
      <SeparatorText>{value}</SeparatorText>
      <SeparatorLine />
    </BaseSeparator>
  );
};
